import { Button, Textarea } from 'design-system';
import { Send } from 'lucide-react';

import { useMessageInput } from './useMessageInput';

const MessageInput = ({ maxRows }: { maxRows: number }) => {
  const { inputMessage, isDisabled, handleSend, handleChange, handleKeyDown } = useMessageInput();

  return (
    <div className='shrink-0 border-t border-gx-border px-6 pb-3 pt-5'>
      <div className='mx-auto flex max-w-[48rem] items-end gap-3 rounded-xl border border-gx-border bg-gx-tile-dark/55 p-2.5 shadow-[0_12px_32px_rgba(0,0,0,0.16)] transition-colors focus-within:border-gx-highlight/70'>
        <div className='min-w-0 flex-1'>
          <Textarea
            aria-label='Enter your prompt'
            className='min-h-12 resize-none border-0 bg-transparent px-1.5 py-1 text-sm leading-6 placeholder:text-gx-subtext focus-visible:ring-0 dark:bg-transparent'
            placeholder='Ask about GX data...'
            rows={1}
            style={{ maxHeight: `${maxRows * 24 + 8}px` }}
            value={inputMessage}
            onChange={e => {
              handleChange(e.target.value);
            }}
            onKeyDown={handleKeyDown}
          />
          <p className='px-1.5 pt-1 text-[11px] leading-4 text-gx-text-disabled'>
            Enter to send · Shift + Enter for a new line
          </p>
        </div>
        <Button
          aria-label='Send prompt'
          className='size-10 shrink-0 bg-gx-highlight text-white hover:bg-gx-highlight-light disabled:bg-gx-action-bar-button-tile disabled:text-gx-text-disabled disabled:opacity-100'
          disabled={isDisabled || !inputMessage.trim()}
          size='icon-lg'
          onClick={handleSend}
        >
          <Send className='size-4.5' />
        </Button>
      </div>
    </div>
  );
};

export default MessageInput;
